module.exports = __webpack_public_path__ + "img/bot_zf.f84cd1c0.png";